import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MSWORD_FORMAT_FILES_NOT_ALLOWED,
  MAX_SIZE_FILE,
  MAX_TOTAL_SIZE,
  TYPE_FILE_ALLOWED,
  IMAGE_FORMAT_FILES_NOT_ALLOWED,
  OPENXML_FORMAT_FILES_NOT_ALLOWED,
} from '@app/@core/constants/requests.constants';
import { AttachDocumentsFilesDTO } from '@app/requests/model/requests-model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'scf-drag-drop-update',
  templateUrl: './drag-drop-update.component.html',
  styleUrls: ['./drag-drop-update.component.scss'],
})
export class DragDropUpdateComponent implements OnInit {
  @Input() numOperation: string;
  @Input() limitOfFiles: number;
  @Input('reset') set reset(data: any) {
    if (data) {
      this.files = [];
    }
  }
  @Input() isEnabled: boolean;
  @Output() saveFiles = new EventEmitter<any[]>();
  public files: any[] = [];
  public totalSize: number = 0;
  filesToSendEnd: AttachDocumentsFilesDTO;

  constructor(private _snackBar: MatSnackBar, public dialog: MatDialog, public translate: TranslateService) {}

  ngOnInit(): void {
    if (this.isEnabled === null || this.isEnabled === undefined) {
      this.isEnabled = true;
    }
  }

  getCloseName(): string {
    return this.translate.instant('uploadDocuments.close');
  }

  resetEventFile(input: HTMLInputElement) {
    if (input) {
      input.value = '';
    }
  }

  uploadFile(pFileList: File[], input: HTMLInputElement) {
    const close = this.getCloseName();
    for (let file of pFileList) {
      if (file.size <= 0 || file.size > MAX_SIZE_FILE) {
        this.resetEventFile(input);
        this._snackBar.open(this.translate.instant('uploadDocuments.incorrectWeight'), close, {
          duration: 5000,
        });
      } else if (
        !TYPE_FILE_ALLOWED.includes(file.type) ||
        (TYPE_FILE_ALLOWED.includes(file.type) &&
          (IMAGE_FORMAT_FILES_NOT_ALLOWED.includes(file.name.substring(file.name.lastIndexOf('.'), file.name.length)) ||
            MSWORD_FORMAT_FILES_NOT_ALLOWED.includes(
              file.name.substring(file.name.lastIndexOf('.'), file.name.length)
            ) ||
            OPENXML_FORMAT_FILES_NOT_ALLOWED.includes(
              file.name.substring(file.name.lastIndexOf('.'), file.name.length)
            )))
      ) {
        this.resetEventFile(input);
        this._snackBar.open(this.translate.instant('uploadDocuments.incorrectFormat'), close, {
          duration: 5000,
        });
      } else if (this.checkIfRepeated(file)) {
        this.resetEventFile(input);
        this._snackBar.open(this.translate.instant('uploadDocuments.duplicated'), close, {
          duration: 5000,
        });
      } else {
        this.totalSize += Number(file.size);
        if (this.totalSize > MAX_TOTAL_SIZE) {
          this.resetEventFile(input);
          this.totalSize -= Number(file.size);
          this._snackBar.open(this.translate.instant('uploadDocuments.maxWeightExceded'), close, {
            duration: 5000,
          });
        } else {
          this.files.push(file);
          const input = document.getElementById('file') as HTMLInputElement | null;
          input.value = null;
          this._snackBar.open(this.translate.instant('uploadDocuments.fileUploadCorrectly'), close, {
            duration: 5000,
          });
          this.saveFiles.emit(this.files);
        }
      }
    }
  }

  setFilesMethod(input: HTMLInputElement): File[] {
    const pFileList: File[] = [];
    if (input.files) {
      const filesArray = Array.from(input.files);
      for (const file of filesArray) {
        pFileList.push(file);
      }
    }
    return pFileList;
  }

  dropEventMethod(dropEvent: DragEvent): File[] {
    const pFileList: File[] = [];
    if (dropEvent.dataTransfer && dropEvent.dataTransfer.files) {
      const filesArray = Array.from(dropEvent.dataTransfer.files);
      for (const file of filesArray) {
        pFileList.push(file);
      }
    }
    return pFileList;
  }

  onFileChange(event: any, uploadType: string) {
    const input = event.target as HTMLInputElement;
    //if this.limitOfFiles is undefined the user can upload files without limit
    let pFileList: File[] = [];
    if (uploadType === 'selected') {
      pFileList = this.setFilesMethod(input);
    } else if (uploadType === 'dropped') {
      pFileList = event;
    }
    if ((pFileList !== null && pFileList.length <= this.limitOfFiles) || undefined === this.limitOfFiles) {
      this.uploadFile(pFileList, input);
    } else {
      this.resetEventFile(input);
      this._snackBar.open(
        `${this.translate.instant('uploadDocuments.numFilesAllowed')} ${this.limitOfFiles}`,
        this.getCloseName(),
        {
          duration: 5000,
        }
      );
    }
  }

  deleteFile(f: any) {
    this.files = this.files.filter(function (w) {
      return w.name != f.name;
    });
    this.totalSize -= f.size;
    this.saveFiles.emit(this.files);
  }

  deleteFromArray(index: number, f: File) {
    this.files.splice(index, 1);
    this.totalSize -= f.size;
    this._snackBar.open(this.translate.instant('uploadDocuments.fileNotUploaded'), this.getCloseName(), {
      duration: 3000,
    });
    this.saveFiles.emit(this.files);
  }

  checkIfRepeated(file: File): boolean {
    return (
      this.files.filter((element) => {
        return (
          (element.name.substring(0, 10) === file.name.substring(0, 10) || element.name === file.name) &&
          element.size === file.size
        );
      }).length > 0
    );
  }
}
